export function createError(error) {
    let message;
    const formError = error?.response?.data?.errors?.[0]
    if (formError) {
        message = `${formError?.msg} in ${formError?.param}`
    } else {
        message = error?.response?.data?.message || error?.error?.message || error?.reason || error?.message
    }
    return message;
}